import { useEffect, useState } from 'react'

type Domain = 'local' | 'staging' | null

// NOTE: ドメイン判定ロジックをこのコンポーネント内に持たせている
// root.tsxのLayout内でuseEffect + setStateを使うと再レンダリングが発生し、
// QueryClientの再生成によりReact Queryのキャッシュがリセットされる問題があるため
export const DomainFloatingMessage = () => {
  const [domain, setDomain] = useState<Domain>(null)

  useEffect(() => {
    const hostname = window.location.hostname
    if (
      hostname.indexOf('localhost') !== -1 ||
      hostname.indexOf('127.0.0.1') !== -1 ||
      hostname.indexOf('.local') !== -1
      //MEMO: ローカル環境で他ドメインで動作させている方はここに追加してください
    ) {
      setDomain('local')
    } else if (hostname.indexOf('staging') !== -1) {
      setDomain('staging')
    }
  }, [])

  if (!domain) return null

  const config = {
    local: {
      message: 'Local environment',
      styleClass: 'bg-notification-attention-1-2 text-black',
    },
    staging: {
      message: 'Staging environment',
      styleClass: 'bg-notification-true-1-2 text-white',
    },
  }

  const { message, styleClass } = config[domain]

  return (
    <div
      className={`animate-blink fixed bottom-2.5 right-2.5 z-[99999] px-4 py-2.5 rounded-md drop-shadow-lg pointer-events-none ${styleClass}`}
    >
      <span className='text-base font-medium'>{message}</span>
    </div>
  )
}